import { Badge } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LoginMsgContext } from "../../router/router";
import { getText } from "../../utils/util";
import "./index.css";

export default function BottomBar({ index }) {
  const { t: translate } = useTranslation();
  const [loginmsg, setloginmsg] = useContext(LoginMsgContext);
  const navigate = useNavigate();
  const companySkin = localStorage.getItem("companySkin");
  
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="flex items-center justify-between px-2 py-1 bg-neutral-900 border-t border-neutral-800">
        
        <button 
          onClick={() => navigate("/homecenter")}
          className={`flex-1 flex flex-col items-center justify-center py-2 transition-all duration-200 ${
            index == 1 ? 'text-primary' : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <div className="w-6 h-6 mb-1">
            <img
              src={index == 1 ? "/home/2.png" : "/home/1.png"}
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-tiny">{translate(getText("首頁"))}</span>
        </button>

        <button
          onClick={() => navigate("/quotation")}
          className={`flex-1 flex flex-col items-center justify-center py-2 transition-all duration-200 ${
            index == 2 ? 'text-primary' : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <div className="w-6 h-6 mb-1">
            <img
              src={index == 2 ? "/home/4.png" : "/home/3.png"}
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-tiny">{translate(getText("行情"))}</span>
        </button>

        <button
          onClick={() => navigate("/trade/btc")}
          className={`flex-1 flex flex-col items-center justify-center py-2 transition-all duration-200 ${
            index == 3 ? 'text-primary' : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <div className="w-6 h-6 mb-1">
            <img
              src={index == 3 ? "/home/6.png" : "/home/5.png"}
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-tiny">{translate(getText("交易"))}</span>
        </button>

        <button
          onClick={() => navigate("/propertycenter")}
          className={`flex-1 flex flex-col items-center justify-center py-2 transition-all duration-200 ${
            index == 4 ? 'text-primary' : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <div className="w-6 h-6 mb-1">
            <img
              src={index == 4 ? "/home/16.png" : "/home/15.png"}
              className="w-full h-full object-contain"
            />
          </div>
          <span className="text-tiny">{translate(getText("資產"))}</span>
        </button>

        <button
          onClick={() => navigate("/mycenter")}
          className={`flex-1 flex flex-col items-center justify-center py-2 transition-all duration-200 ${
            index == 5 ? 'text-primary' : 'text-neutral-400 hover:text-neutral-200'
          }`}
        >
          <div className="w-6 h-6 mb-1">
            <img
              src={index == 5 ? "/home/10.png" : "/home/9.png"}
              className="w-full h-full object-contain" 
            />
          </div>
          <span className="text-tiny">{translate(getText("我的"))}</span>
        </button>

      </div>
    </div>
  );
}
